import { getCookie } from "../utils/cookies";
const baseUrl = process.env.REACT_APP_API_ENDPOINT || "/";

const httpClient = async (endpoint, { method = "GET", headers = {}, body } = {}) => {
    const token = getCookie("cck_user");

    const config = {
        method,
        headers: {
            "Content-Type": "application/json",
            "Authorization": token,
            ...headers,
        },
    };

    if (body) {
        config.body = JSON.stringify(body);
    }

    try {
        const response = await fetch(`${baseUrl}${endpoint}`, config);
        const responseData = await response.json();

        return { status: response.status, data: responseData };
    } catch (error) {
        console.error("HTTP error: ", error);
        throw error;
    }
};

export default httpClient;
